import * as z from "zod/v4";

export const deleteShipmentViewFolder = {
  name: "deleteShipmentViewFolder" as const,
  input: z.object({ folderId: z.string() }),
  output: z.object({}),
};
